<!-- TODO: Improve placeholder (loading badge style with blurry background would be great)-->
@if (dynamicLoadingService.isLoadingDynamicModule) {
  <div
    style="height: 100vh; width: 100vw; position: fixed; top: 0; left: 0; z-index: 64500; background-color: white"
    class="d-flex flex-column justify-content-center align-items-center loading-background"
  >
    <div class="d-flex justify-content-center align-items-center">
      <mat-spinner [diameter]="36"></mat-spinner>
      <p class="ml-3">{{ dynamicLoadingService.loadingMessage }}&hellip;</p>
    </div>
  </div>
}
<div class="skeleton-body">
  @if (!hasLoadedData || isCreatingRedirectToken || isLoggingOut) {
    <div
      style="height: 100vh; width: 100vw"
      class="d-flex flex-column justify-content-center align-items-center loading-background"
    >
      <div class="d-flex justify-content-center align-items-center">
        <mat-spinner [diameter]="36"></mat-spinner>
        @if (!isLoggingOut) {
          <span style="font-size: 14pt" class="ml-3">{{
            isCreatingRedirectToken ? 'Redirecting to Shop' : 'Fetching profile data'
          }}</span>
        }
        @if (isLoggingOut) {
          <span style="font-size: 14pt" class="ml-3">Logging Out&hellip;</span>
        }
      </div>
    </div>
  }
  @if (hasLoadedData && !isCreatingRedirectToken && !isLoggingOut) {
    <div style="width: 100vw; height: 100vh">
      <v2-header></v2-header>
      <div class="d-flex">
        @if (isDesktopView) {
          <app-sidenav
            class="sidenav"
            [customerApps]="customerApps"
            (onCustomerPortalClicked)="onCustomerPortalClicked($event)"
            (onCustomerPortalKeydown)="onCustomerPortalKeydown($event)"
          ></app-sidenav>
        }
        @if (!isDesktopView) {
          <app-sidenav-collapsed
            class="sidenav"
            [customerApps]="customerApps"
            (onCustomerPortalClicked)="onCustomerPortalClicked($event)"
            (onCustomerPortalKeydown)="onCustomerPortalKeydown($event)"
          ></app-sidenav-collapsed>
        }
        <!-- Nested method used to keep the footer at the bottom on any screen size -->
        <div class="bg-empty w-100" style="height: calc(100vh - 65px); overflow: hidden; margin-top: 65px">
          <div
            class="d-flex flex-column justify-content-between w-100"
            style="height: calc(100vh - 55px); overflow: auto"
          >
            <!-- Hub content -->
            <div class="flex-grow-1">
              <router-outlet></router-outlet>
            </div>
            <!-- Hub Footer -->
            <div class="sidenav-footer">
              <p style="margin-bottom: 5px">
                Copyright © {{ now | date: 'yyyy' }}&nbsp;<a href="https://udtonline.com/" target="_blank"
                  >United Data Technologies</a
                >
              </p>
              <p>Want to provide Feedback? Contact us <a href="mailto:HUBsupport@udtonline.com">here</a></p>
              <div class="text-center">
                <a class="btn social-fab--sm" href="https://www.linkedin.com/company/udtcorp/" target="_blank">
                  <i class="fab fa-linkedin" aria-label="Linkedin logo"></i>
                </a>
                <a class="btn social-fab--sm" href="https://twitter.com/UDTCorp" target="_blank">
                  <i class="fab fa-twitter" aria-label="Twitter logo"></i>
                </a>
                <a class="btn social-fab--sm" href="https://www.facebook.com/UDTCorp/" target="_blank">
                  <i class="fab fa-facebook" aria-label="Facebook logo"></i>
                </a>
                <a class="btn social-fab--sm" href="https://www.instagram.com/udtcorp/" target="_blank">
                  <i class="fab fa-instagram" aria-label="Instagram logo"></i>
                </a>
                <a class="btn social-fab--sm" href="https://www.youtube.com/user/UDTvideo" target="_blank">
                  <i class="fab fa-youtube" aria-label="YouTube logo"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
